import { UPDATEROLE_SUCCESS, UPDATEROLE_FAIL } from '../actionTypes';

const initialState = {
    user: null
};

const updateRoleReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATEROLE_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case UPDATEROLE_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }
    return state;
};

export default updateRoleReducer;
